import { useChangePassword } from '@/query/queries/user/useChangePassword';
import ChangePassForm from '@/components/Forms/ChangePassForm';

const ChangePasswordModal = ({ onClose }) => {
  const { mutateAsync: changePassword } = useChangePassword();

  const onSubmit = async values => {
    const payload = {
      old_password: values.oldPassword,
      new_password: values.password1,
    };
    const res = await changePassword(payload);
    res && onClose();
  };

  return <ChangePassForm onSubmit={onSubmit} onCancel={onClose} />;
};

export default ChangePasswordModal;
